"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTask_1 = require("./BaseTask");
/**
 * [[ParallelGroupTask]] runs a set of tasks in parallel. When canceled, it
 * stops any currently running tasks.
 */


var ParallelGroupTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(ParallelGroupTask, _BaseTask_1$default);

  var _super = _createSuper(ParallelGroupTask);

  function ParallelGroupTask(logger, taskName, tasksToRunParallel) {
    var _this;

    _classCallCheck(this, ParallelGroupTask);

    _this = _super.call(this, logger);
    _this.taskName = taskName;
    _this.tasksToRunParallel = tasksToRunParallel;

    var _iterator = _createForOfIteratorHelper(tasksToRunParallel),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var task = _step.value;
        task.setParent(_assertThisInitialized(_this));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return _this;
  }

  _createClass(ParallelGroupTask, [{
    key: "cancel",
    value: function cancel() {
      var _iterator2 = _createForOfIteratorHelper(this.tasksToRunParallel),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var task = _step2.value;
          this.logger.info("canceling parallel group task ".concat(this.name(), " subtask ").concat(task.name()));
          task.cancel();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var taskResults, _iterator3, _step3, task, failures, i, failureMessage;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                taskResults = [];
                _iterator3 = _createForOfIteratorHelper(this.tasksToRunParallel);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    task = _step3.value;
                    this.logger.info("parallel group task ".concat(this.name(), " running subtask ").concat(task.name()));
                    taskResults.push(task.run());
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                failures = [];
                i = 0;

              case 5:
                if (!(i < taskResults.length)) {
                  _context.next = 18;
                  break;
                }

                _context.prev = 6;
                _context.next = 9;
                return taskResults[i];

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](6);
                failures.push("task ".concat(this.tasksToRunParallel[i].name(), " failed: ").concat(_context.t0.message));

              case 14:
                this.logger.info("parallel group task ".concat(this.name(), " completed subtask ").concat(this.tasksToRunParallel[i].name()));

              case 15:
                i++;
                _context.next = 5;
                break;

              case 18:
                if (failures.length > 0) {
                  failureMessage = failures.join(', ');
                  this.logAndThrow("parallel group task ".concat(this.name(), " failed for tasks: ").concat(failureMessage));
                }

                this.logger.info("parallel group task ".concat(this.name(), " completed"));

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 11]]);
      }));
    }
  }]);

  return ParallelGroupTask;
}(BaseTask_1.default);

exports.default = ParallelGroupTask;